import { configHome, configTeaser, DataSource } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  ContentBlock,
  CustomClassContext,
  LatestArticle,
  NaturalCarousel,
  SectionContext,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode, useContext } from "react";

import styles from "../homelayout.module.css";
import { extractHomeContentData, HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
  alternateBg?: boolean;
  trendingBlock?: boolean;
  scrollable?: boolean;
};

// ContentBlock 3 items | Trending | Content Block D
export default function HomeContentBlockD({
  data,
  dataSource,
  alternateBg,
  trendingBlock,
  scrollable,
}: Props): ReactNode {
  const ContentBlockThreeItems = extractHomeContentData(data, dataSource);
  const customClass = useContext(CustomClassContext);
  const mappedItems =
    ContentBlockThreeItems &&
    ContentBlockThreeItems.items.map((contentBlockItem, index) => {
      return (
        <div
          className={cx(styles.content, customClass?.homeContentBlockD?.item)}
          key={index}
        >
          <LatestArticle
            {...contentBlockItem}
            sections={
              configHome.contentBlockD?.skipSection
                ? []
                : contentBlockItem.sections
            }
            mode={
              configHome.contentBlockD?.squareIndexes?.includes(index)
                ? "square"
                : configHome.contentBlockD?.crop || "portrait"
            }
            mobileMode={configHome.contentBlockD?.mobileMode}
            placeholders={placeholders}
            descriptionInTitle={configHome.contentBlockD?.descriptionInTitle}
            displayPublishDate={configTeaser.publishDate}
            dateAfter={configTeaser.dateAfter}
          />
        </div>
      );
    });
  return (
    !!ContentBlockThreeItems?.items.length && (
      <div
        className={cx(
          alternateBg && styles.backgroundFill,
          trendingBlock && styles.trendingAltStyle,
        )}
      >
        <div
          className={cx(
            styles.bodyContainer,
            styles.gutter,
            styles.contentBlockDContainer,
            customClass?.homeContentBlockD?.container,
            trendingBlock && customClass?.homeContentBlockD?.altStyleContainer,
          )}
        >
          <ContentBlock
            heading={ContentBlockThreeItems.title}
            headingZH={ContentBlockThreeItems.titleZH}
            cta={{
              name: ContentBlockThreeItems.cta
                ? configHome.contentBlockF?.viewMore?.text || "VIEW ALL"
                : undefined,
              url: ContentBlockThreeItems.url,
              icon: configHome.viewMore?.icon,
            }}
            withDivider={configHome.headingDivider}
            isHeadingClickable={configHome.isHeadingClickable}
          >
            <SectionContext.Provider
              value={{
                uniqueName: ContentBlockThreeItems.uniqSectionName,
              }}
            >
              <div
                className={cx(
                  styles.contentBlockContainer,
                  trendingBlock &&
                    customClass?.homeContentBlockD?.itemContainerAltStyle,
                  scrollable && customClass?.homeContentBlockD?.scroll,
                )}
              >
                {scrollable ? (
                  <div className={styles.contentBlockDScrollabel}>
                    <NaturalCarousel isLooping={false}>
                      {mappedItems}
                    </NaturalCarousel>
                  </div>
                ) : (
                  mappedItems
                )}
              </div>
            </SectionContext.Provider>
          </ContentBlock>
        </div>
      </div>
    )
  );
}
